import React from 'react';
import { compose } from 'recompose';
import Layout from '../utils/layout';
import { graphql } from 'gatsby';
import {
  withAuthorization,
  withEmailVerification,
} from '../utils/Session';
import Upload from '../components/scenes/Upload/Uploadfile';

const condition = authUser => !!authUser;
const UploadPage = compose(
  withEmailVerification,
  withAuthorization(condition),
)(Upload);

export default () => {
  return (
    <Layout>
      <UploadPage />
    </Layout>
  );
};

export const query = graphql`
  query UploadSeo {
    site {
      siteMetadata {
        home {
          defaultTitle: title
          titleTemplate
          defaultDescription: description
          siteUrl: url
          defaultImage: image
          twitterUsername
        }
      }
    }
  }
`;
